import { render, staticRenderFns } from "./TestInstallOrderModalTVn.vue?vue&type=template&id=c4de9042"
import script from "./TestInstallOrderModalTVn.vue?vue&type=script&lang=js"
export * from "./TestInstallOrderModalTVn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports